import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import type { ChartSpec } from "@/lib/chat-api";

const COLOURS = [
  "#2563eb",
  "#16a34a",
  "#f59e0b",
  "#dc2626",
  "#9333ea",
  "#0891b2",
  "#db2777",
  "#65a30d",
];

interface ChatChartProps {
  spec: ChartSpec;
  rows: Record<string, unknown>[];
}

export function ChatChart({ spec, rows }: ChatChartProps) {
  if (!rows || rows.length === 0) return null;

  if (spec.type === "bar") {
    return (
      <div className="h-64 my-2">
        <ResponsiveContainer>
          <BarChart data={rows}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={spec.x} />
            <YAxis />
            <Tooltip />
            <Bar dataKey={spec.y} fill={COLOURS[0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }

  if (spec.type === "line") {
    return (
      <div className="h-64 my-2">
        <ResponsiveContainer>
          <LineChart data={rows}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={spec.x} />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey={spec.y} stroke={COLOURS[0]} strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }

  return (
    <div className="h-64 my-2">
      <ResponsiveContainer>
        <PieChart>
          <Tooltip />
          <Pie data={rows} dataKey={spec.y} nameKey={spec.x} outerRadius={80} label>
            {rows.map((_, i) => (
              <Cell key={i} fill={COLOURS[i % COLOURS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
